import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { SnackbarProvider } from 'notistack'

import CommonNotistack from "./components/common/CommonNotistack"

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/unuse/chart';
// import ScrollToTop from './components/unuse/scroll-to-top';

// ----------------------------------------------------------------------

import { init } from './hooks/useTranslations';

export default function App() {

  // const { init } = useTranslations({ ns: [] })

  // init i18n
  init();

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          {/* <ScrollToTop /> */}
          <StyledChart />
          <Router />

          <SnackbarProvider
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            Components={{
              commonNotistack: CommonNotistack
            }}
          />

        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
